import {Modal, Col, Row, Form} from 'react-bootstrap';
import React, { useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';
import { validateFormFields } from '../../../utils';
import {FormInput} from '../../../components/formElements/FormInput';
import CommonService from '../../../services/CommonService';
import swal from 'sweetalert';
import CurrencyInput from '../../formElements/CurrencyInput'
import BaseService from '../../../services/BaseService';
import { Typeahead } from 'react-bootstrap-typeahead';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {FaCalendarAlt} from 'react-icons/fa';

const EditAdtr = (props) => {
    const user = useContext(UserContext);
    const {onModalClose, adtrInfo} = props;
    const [formErrors, setFormErrors] = useState({});
    const [count, setCount] = useState(0);
    const [bgcolor, setBgcolor] = useState('yellowgreen');
    const [adtr, setAdtr] = useState({...adtrInfo});
    const [contacts, setContacts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);


    const adtrStatus = [
        {
            statusFlag: "C",
            statusName: "Cancelled"
        },
        {
            statusFlag: "D",
            statusName: "Draft"
        },
        {
            statusFlag: "R",
            statusName: "Reviewed"
        },
        {
            statusFlag: "S",
            statusName: "Submitted"
        },
    ]

    const getContacts = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAllContacts",
      hdrStruct: null,
      queryParam: null,
      reqData: {},
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setContacts(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }
  useEffect(() => {
    getContacts();
    // eslint-disable-next-line
  }, []);


    const handleAdtrChange = e => {
            const { name } = e.target;
            let value = e.target.value;
            setAdtr(prevState => ({
                ...prevState, [name]: value
            }))
    }
   
    const handleCommentValue = (e, key) => {
        setCount(e.target.value.length);
        const color = (e.target.value.length === 4000) ? 'orangered' : 'yellowgreen';
        setBgcolor(color);
        setAdtr(prevState => ({
            ...prevState, [key] : e.target.value
        }))
    };

    const handleDateChange = (e, key) => {
        console.log(e, key)
        setAdtr(prevState=>({
            ...prevState, 
            [key]: e??''
        })
        )
    }

    const handleTypeaheadChange = (e, key) => {
        const selectedValue =  e.length > 0 ? e[0][key] : ""
        setAdtr(prevState=>({
            ...prevState, 
            [key]: selectedValue
        })
        )
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target.closest('form#edit-adtr');
        let formErrors = validateFormFields(form.elements);
        console.log(formErrors)
        if(Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors);
        } else {  
            setFormErrors({});
            var obj = {
                msgId: null,
                sysId: null,
                opr: "putAdtrUpdate",
                hdrStruct: null,
                queryParam: null,
                reqData: { 
                    "adtr" : {
                        "cdiacNbr": adtr.cdiacNbr,
                        "adtrId": adtr.adtrId,
                        "finalSaleId": adtr.finalSaleId,
                        "fiscalYrEndDate": adtr.fiscalYrEndDate,
                        "statusFlag": adtr.statusFlag,
                        "contactId": adtr.contactId,
                        "rptPeriodBeginBalAmt": adtr.rptPeriodBeginBalAmt,
                        "accretedInterestAmt": adtr.accretedInterestAmt,
                        "principalRedeemAmt": adtr.principalRedeemAmt,
                        "principalOtherPaidAmt": adtr.principalOtherPaidAmt,
                        "filingDate": adtr.filingDate,
                        "issuerComment": adtr.issuerComment,
                        "lastUpdateUser": CommonService.getUserName(user)
                    }
                },
            };
        
            BaseService.processRequest(obj)
                .then((result) => {
                    if (result.data.errors && result.data.errors.length > 0){
                            toast.error(result.data.errors[0].message)
                    }
                    else{
                        toast.success("ADTR updated successfully!");
                        onModalClose();
                    }

                });
        }
    }
    
    return (
        <Modal show={true} backdrop="static" onHide={onModalClose}>
            <Modal.Header closeButton><h3>Edit ADTR</h3></Modal.Header>
            <Modal.Body>
            <form id="edit-adtr">
                <div className="contactForm">
                    <Row>
                            <Col md={6} className="control">
                                <FormInput
                                    label="CDIAC#"
                                    type="text"
                                    value={adtr.cdiacNbr}
                                    disabled
                                    readOnly
                                />
                            </Col>
                            <Col md={6} className="control">
                                <FormInput
                                    label="Fiscal Year End Date"
                                    type="text"
                                    value={CommonService.dateFormatter(adtr.fiscalYrEndDate)}
                                    disabled
                                    readOnly
                                />
                            </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="control">
                                    <span className="required">* </span>
                                    <CurrencyInput
                                    placeholder="0.00"
                                    label="Report Period Begin Balance Amount"
                                    name="rptPeriodBeginBalAmt"
                                    type="text"
                                    onChange={(e) => handleAdtrChange(e)}
                                    value={adtr.rptPeriodBeginBalAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                                {formErrors['rptPeriodBeginBalAmt'] && <span className="error">{formErrors['rptPeriodBeginBalAmt']}</span>}

                        </Col>

                        <Col md={6} className="control">
                                 <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="Accreted Interest Amount"
                                    name="accretedInterestAmt"
                                    type="text"
                                    onChange={(e) => handleAdtrChange(e)}
                                    value={adtr.accretedInterestAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                                {formErrors['accretedInterestAmt'] && <span className="error">{formErrors['accretedInterestAmt']}</span>}
                        </Col>
                    </Row>
                    <Row>                       
                        <Col md={6} className="control">
                            <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="Principal Other Paid Amount"
                                    name="principalOtherPaidAmt"
                                    type="text"
                                    onChange={(e) => handleAdtrChange(e)}
                                    value={adtr.principalOtherPaidAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                            {formErrors['principalOtherPaidAmt'] && <span className="error">{formErrors['principalOtherPaidAmt']}</span>}
                        </Col>
                            <Col md={6} className="control">
                                <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="Principal Redeem Amount"
                                    name="principalRedeemAmt"
                                    type="text"
                                    onChange={(e) => handleAdtrChange(e)}
                                    value={adtr.principalRedeemAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                                {formErrors['principalRedeemAmt'] && <span className="error">{formErrors['principalRedeemAmt']}</span>}

                            </Col>
                    </Row>
                    <Row>
                            <Col md={6} className="control">
                                    <label><span className="required">* </span>Filing Date: </label>
                                    <div>
                                        <span>
                                            <DatePicker
                                                selected={adtr.filingDate ? new Date(adtr.filingDate) : null}
                                                dateFormat="M/d/yyyy"
                                                maxDate={new Date(9999, 12, 31)}
                                                name="filingDate1"
                                                onChange={(e) => handleDateChange(e, 'filingDate')}
                                            />
                                            <FaCalendarAlt className="date-picker-icon" />
                                        </span>
                                        {formErrors.filingDate && <p className="error">Filing Date is required</p>}
                                        <input type="hidden" data-validations={["required"]} value={adtr.filingDate} name="filingDate" />
                                    </div>
                            </Col>
                            <Col md={6} className="control">
                                    <label><span className="required">*</span>ADTR Status: </label>
                                    <Typeahead
                                        placeholder="Choose an ADTR Status"
                                        id="statusId"
                                        name="statusId"
                                        labelKey="statusName"
                                        onChange={e => handleTypeaheadChange(e, 'statusFlag')}
                                        inputProps={{ 'data-validations': 'required', name: 'statusFlag' }}
                                        options={adtrStatus}
                                        selected={
                                            adtrStatus.filter(option =>
                                                option.statusFlag === adtr.statusFlag)
                                        }
                                        isLoading={isLoading}
                                    />
                                {formErrors.statusFlag && <p className="error">Status is required</p>}
                            </Col>
                    </Row>
                    <Row>
                        <div className="control">
                          <label><span className="required">*</span>ADTR Contact: </label>
                          <Typeahead
                            placeholder="Choose a contact"
                            id="contactId"
                            labelKey="contactFullName"
                            onChange={e=>handleTypeaheadChange(e, 'contactId')}
                            inputProps={{ 'data-validations': 'required', name: 'contactId' }}
                            options={contacts}
                            selected = {
                                contacts.filter(option => 
                                    option.contactId === adtr.contactId)
                                }
                                isLoading = {isLoading}
                          />
                      </div>
                      {formErrors.contactId && <p className="error">Contact is required</p>}
                    </Row>
                    <Row>
                    <div>
                        <label>Comment: </label>
                        <div className="comments-box">
                            <textarea name="contactComment" value={adtr.issuerComment}
                            id="comments-input" onChange={(e)=>handleCommentValue(e,'issuerComment')}
                            className="form-control" rows="5" maxLength="4000" placeholder="Add a comment..."/>
                            <span style={{position: 'relative', left: '45%' , backgroundColor: bgcolor }}>{count} out of 4000 max</span>
                        </div>
                    </div>
                    </Row>
                </div>
                <div className="btn-div">
                <div className="fright">
                    <button type="button" className="custom-button-secondary  btn-secondary" onClick={onModalClose}>Cancel</button>{" "}
                    <button className="custom-button" type="button" onClick={(e)=>handleSubmit(e)}>Update ADTR</button>
                    </div>
                </div>
            </form>                
            </Modal.Body>
        </Modal>
    )
}

export default EditAdtr
